import { AuthTokenType } from 'features/auth/types';
import { TokenResponse } from 'types/login';
import { isLocalHost } from 'utility/constant';
import { getRandomIP, isMatch, isNotEmpty } from 'utility/functions';

export { doGet as ssrGET } from './ssr';
export { doGet as webGET } from './web';

export const emptyToken: TokenResponse = { token_type: '', access_token: '', refresh_token: '', expires_in: -1 };

export const getClientIp = (req?: { headers?: any }, skipLocal = false) => {
  const trueClientIp = Reflect.get(req?.headers, 'true-client-ip');
  if (isNotEmpty(trueClientIp)) {
    return trueClientIp;
  }

  const xForwardedFor = Reflect.get(req?.headers, 'x-forwarded-for');
  // console.log(`fowaredRef`, xForwardedFor);
  if (!isMatch(xForwardedFor, '127(\\.0){2}.1|0(\\.0){3}|(:{2})1$')) {
    return xForwardedFor;
  }

  if (isLocalHost && !skipLocal) {
    return getRandomIP();
  }
};

export const parseToken = (data: TokenResponse, dtNow: Date): AuthTokenType => {
  let { expires_in, access_token, refresh_token, ...oth } = data ?? {};

  const ts = dtNow.getTime();
  const expiresIn = expires_in * 0.9;
  const exp = new Date(dtNow.setSeconds(dtNow.getSeconds() + expiresIn));

  const result: AuthTokenType = {
    ...oth,
    ts,
    expiresIn,
    expireDate: exp.getTime(),
    accessToken: access_token,
    refreshToken: refresh_token,
  };

  return result;
};
